import React from 'react';
import {DropdownItem, isSelected, Scrollbar, Text} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../../../../Localization';
import {AutomationChoose} from '../../../../../reducer/model';
import {ExpandableOptionType} from './types';
import {texts} from '../../../../../texts';
import styles from './styles.module.scss';

type Props = {
    values: Array<string | number>;
    onSelect: (option: AutomationChoose, selected: boolean) => void;
    data: Array<ExpandableOptionType>;
    searchString: string;
    focusedIndex?: number;
};

export const ExpandOptions = (props: Props) => {
    const {data, onSelect, values, searchString, focusedIndex} = props;

    return (
        <div className={styles.optionsBorder}>
            <Scrollbar
                autoHeightMax={160}
                autoHeight
                rtl={isRTL()}
                shiftVerticalScrollPositionX={6}
            >
                <div className="pui-dropdown-options">
                    {data.length > 0 ? (
                        data.map(item => (
                            <DropdownItem
                                key={`${item.value}-${item.label}`}
                                isMulti
                                data={item}
                                onSelect={onSelect}
                                isFocused={focusedIndex === item.data?.index}
                                itemBorder={false}
                                isSelected={isSelected(item, values, true)}
                                searchString={searchString}
                            />
                        ))
                    ) : (
                        <Text
                            componentClasses={styles.noOptions}
                            skin="paragraph-2"
                            tag="div"
                            textColor="secondary-400"
                        >
                            {texts.no_options_text}
                        </Text>
                    )}
                </div>
            </Scrollbar>
        </div>
    );
};
